module.exports = __webpack_public_path__ + "img/missing-thumb.5c77b8b3.png";